
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/o-tytule",
      function () {
        return require("private-next-pages/o-tytule.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/o-tytule"])
      });
    }
  